import Resources from "../../shared/actions/resourcesActions";

class ProductTypeResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "product_type", "/api/v1/product_types");
  }
}

export default ProductTypeResource;
